import * as React from "react";
import {Field, Form} from "react-final-form";
import Loader from "./Loader";

class Login extends React.Component {

	render() {

		const error = {
			marginTop: '9px',
			marginLeft: '0px',
			color: 'red'
		}

		const getControls = (submitting) => {
			if (submitting) {
				return <Loader/>
			}

			if (this.props.authenticated) {
				const style = {
					backgroundColor: 'green'
				};

				return (<button type="submit" className="login-button" style={style} disabled={true}>Success</button>);
			} else {
				return (<button type="submit" className="login-button">Login</button>);
			}
		};

		const authError = this.props.authError ? (
			<div className="row" style={error}>
				<span>{this.props.authError}</span>
			</div>
		) : null;

		return (
			<Form
				onSubmit={this.props.onSubmit}
				render={({handleSubmit, reset, submitting, pristine, values}) => (
					<form onSubmit={handleSubmit}>
						<div className="form-box">
							<p className="emph">Returning Customers</p>
							<div className="form-group">
								<div className="row">
									<div className="col-sm-6">
										<Field
											name="username"
											component="input"
											type="text"
											placeholder="Username"
											required
											disabled={this.props.authenticated}
										/>
									</div>
									<div className="col-sm-6">
										<Field
											name="password"
											component="input"
											type="password"
											placeholder="Password"
											required
											disabled={this.props.authenticated}
										/>
									</div>
								</div>
								<div className="row">
									<div className="col">
										{getControls(submitting)}
									</div>
								</div>
								{authError}
							</div>
						</div>
					</form>
				)}
			/>
		)
	}
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.jsx